<template>
  <div v-if="!this.$route.params.id && !this.$route.meta.newPage" class="pt-6">
    <fin-greeting id="fin-greeting"
                  v-style:paddingTop="$valueByBreakpoint({xs: '100px', md: '75px'})"
                  v-style:paddingBottom="$valueByBreakpoint({xs: '16px', md: '32px'})"
                  class="fin-color-primary-light"
                  style="margin-top:-100px;"/>
    <v-container v-scroll="onScroll"
                 v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 class="fin-hub"
                 fluid
    >

      <fin-maintenance-info/>

      <!-- PORTFOLIOS -->

      <fin-my-portfolios-wrapper id="fin-portfolios"/>


      <!-- Watchlists -->

      <fin-content-section id="fin-watchlists"
                           :route="{name: 'myWatchlists'}"
                           container-class="py-8"
                           icon="icon-eye"
                           show-more-btn
                           showAllText="Alle Watchlists"
                           :title="watchlistSectionTitle">
        <template #afterTitle>
          <fin-realtime-indicator class="ml-1" trading-platform="tradegate"/>
        </template>

        <template #actions>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" text @click="showCreateWatchlistDialog">
            <fin-subscription-lock v-if="maxWatchlists && watchlists.length >= maxWatchlists"
                                   color="fin-color-primary-dark"/>
            <v-icon v-else>icon-plus</v-icon>
            Neue Watchlist
          </v-btn>
        </template>

        <fin-data-loader ref="watchlistloader" :resolver="loadWatchlists">
          <template #content>
            <fin-my-watchlists :watchlists="watchlists"
                               @reloadWatchlists="$refs.watchlistloader._fetchData()"
                               @showCreateWatchlistDialog="showCreateWatchlistDialog"/>
          </template>
        </fin-data-loader>
      </fin-content-section>

      <!-- TOOLS -->

      <fin-content-section id="fin-tools"
                           :route="{name: 'finTools'}"
                           container-class="py-8"
                           icon="icon-tools"
                           show-more-btn
                           showAllText="Alle Tools"
                           :title="$vuetify.breakpoint.xs ? 'Verfügbare Tools' : 'Tools'">
        <template>
          <fin-tools-wrapper/>
        </template>
      </fin-content-section>


      <!-- MARKET -->

      <fin-content-section id="fin-market"
                           container-class="py-8"
                           icon="icon-chart"
                           title="Aktuelle Marktentwicklung">
        <template>
          <fin-market-wrapper class="mb-6"/>
          <fin-topsflops-wrapper/>
        </template>
      </fin-content-section>


      <!-- NEWS -->

      <fin-content-section v-if="!hideNews"
                           id="fin-news"
                           :route="{name: 'news'}"
                           container-class="py-8"
                           icon="icon-news"
                           show-more-btn
                           showAllText="Zum Liveticker"
                           title="News">
        <template>
          <fin-news-wrapper/>
        </template>
      </fin-content-section>


      <!-- COMMUNITY -->

      <fin-content-section v-if="!hideCommunity"
                           id="fin-community"
                           :route="{name: 'community'}"
                           container-class="py-8"
                           icon="icon-community"
                           show-more-btn
                           showAllText="Zur Community"
                           title="Community">
        <template>
          <fin-community-wrapper/>
        </template>
      </fin-content-section>


      <!-- ACADEMY -->

      <fin-content-section id="fin-academy"
                           v-if="!hideAcademy"
                           :route="{name: 'finAcademy'}"
                           container-class="py-8"
                           icon="icon-academy"
                           show-more-btn
                           showAllText="Zur Academy"
                           title="Academy">
        <template>
          <fin-academy-wrapper/>
        </template>
      </fin-content-section>

      <!-- Contact -->
      <fin-content-section id="fin-contact"
                           container-class="py-8"
                           icon="icon-conversation"
                           :title="$t('contact')">
        <template>
          {{ $t('you_have_questions_or_issues') }}<br/>
          {{ $t('please_contact_our_support') }} <a href="mailto:support@fincraft.de">support@fincraft.de</a>.
        </template>
      </fin-content-section>

      <!-- button temporary here to be able to access the onboarding process -->
      <div v-if="environment === 'development' || environment === 'dev'">
        <v-btn :to="{ name: 'onbgetstarted', params: { continue: 'continue'}}"
               color="fin-color-primary-dark fin-color-primary-light--text" dark tile>
          Zum Onboarding
          <v-icon>icon-arrow-link</v-icon>
        </v-btn>
        <!-- button temporary here to be able to reset the data from the onboarding process -->
        <v-btn color="fin-color-primary-dark fin-color-primary-light--text" id="resetOnboardingBtn"
               dark tile @click="resetOnboardingData">
          Reset Onboarding Data
          <v-icon>icon-arrow-link</v-icon>
        </v-btn>
      </div>

    </v-container>
  </div>

  <router-view v-else/>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import {Analytics} from '@/plugins/finAmplifyModules'
import {finWatchlistAPI} from '@/js/finAPI'
import FinContentSection from '@/components/pages/ContentSection'
import FinNewsWrapper from '@/components/pages/myFinHub/finNews/NewsWrapper'
import FinMyPortfoliosWrapper from '@/components/pages/myFinHub/finPortfolios/MyPortfoliosWrapper.vue'
import FinCommunityWrapper from '@/components/pages/myFinHub/finCommunity/CommunityWrapper'
import FinToolsWrapper from '@/components/pages/myFinHub/finTools/ToolsWrapper'
import FinGreeting from '@/components/pages/myFinHub/finGreeting'
import finAcademyWrapper from '@/components/pages/myFinHub/finAcademy/AcademyWrapper'
import FinMarketWrapper from "@/components/pages/myFinHub/finMarket/MarketWrapper"
import FinMyWatchlists from "@/components/pages/myFinHub/finWatchlists/MyWatchlistsWrapper"
import FinDataLoader from "@/components/common/DataLoader/index"
import FinTopsflopsWrapper from "@/components/pages/myFinHub/finTopsFlops"
import FinRealtimeIndicator from "@/components/common/RealtimeIndicator"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"
import PriceModel from "@/mixins/PriceModel"
import LexiconAPI from "@/components/common/lexicon/LexiconAPI"
import FinMaintenanceInfo from "@/components/common/Maintenance/MaintenanceInfo"
import FinSubscriptionLock from "@/components/common/subscription/lock"

const map = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2

export default {
  name: 'myFinHub',
  components: {
    FinSubscriptionLock,
    FinMaintenanceInfo,
    FinRealtimeIndicator,
    FinTopsflopsWrapper,
    FinDataLoader,
    FinMyWatchlists,
    FinMarketWrapper,
    FinContentSection,
    FinGreeting,
    FinMyPortfoliosWrapper,
    FinToolsWrapper,
    FinNewsWrapper,
    FinCommunityWrapper,
    finAcademyWrapper
  },
  data() {
    return {
      watchlists: [],
      hideAcademy: process.env.VUE_APP_HIDE_ACADEMY_IN_DASHBOARD === 'true',
      hideCommunity: process.env.VUE_APP_HIDE_COMMUNITY === 'true',
      hideNews: process.env.VUE_APP_HIDE_NEWS_ALL === 'true',
      /* for the dialog to create a new portfolio */

      //portfoliosSectionRefreshTime: 0,
      illustrationHeight: 140,
      greetingTopMargin: -150,
      prevRoute: null,
      environment: process.env.NODE_ENV,
      tours: undefined
    }
  },
  mixins: [PriceModel],
  computed: {
    ...mapGetters('auth', ['userId']),
    ...mapState({
      profile: state => state.auth.profile
    }),
    maxWatchlists() {
      return this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.WATCHLIST.id)
    },
    watchlistSectionTitle() {
      let title = 'Deine Watchlists'

      if (this.watchlists.length > this.maxWatchlists) {
        title += '<span style="color: ' + this.$finColors.accentRed + '">'
      }

      title += '&nbsp;(' + this.watchlists.length + ' von ' + (this.maxWatchlists ? this.maxWatchlists : '-') + ')'

      if (this.watchlists.length > this.maxWatchlists) {
        title += '</span>'
      }

      return title
    },
  },
  methods: {
    ...mapActions('auth', ['updateOnboarding']),
    // complete watchlistItem model
    convertItem(item) {
      let convertedItem = item
      // complete model with instrument, so that share and etf can be handled on the same way in the watchlists.
      convertedItem.instrument = item.share || item.etf

      // complete model's timeSeries1M with the latest real time price
      // (do not compare timestamp of close and realtime here, because close always has the time 00:00 and
      // realtime data always has its proper time. close is written at the end of the day so there are no conflicts on the day,
      // but its timestamp cannot be compared to realtime timestamp on Saturday, Sunday and Monday morning)
      if (convertedItem.instrument.latestPrice && convertedItem.instrument.latestPrice.quality === 'RT') {
        item.instrument.mainListing.timeSeries1M.push({
          close: convertedItem.instrument.latestPrice.price,
          timestamp: convertedItem.instrument.latestPrice.timestamp,
          quality: convertedItem.instrument.latestPrice.quality
        })
      }
      return convertedItem
    },
    async loadWatchlists() {
      await finWatchlistAPI.listWatchlists(this.userId).then((mywatchlists) => {
        if (mywatchlists) {
          this.watchlists = mywatchlists
          this.watchlists.forEach(wl => {
            const convertedItems = wl.watched.items.map(entry => this.convertItem(entry))
            wl.watched.items = [...convertedItems]
          })
        }
      })
    },
    showCreateWatchlistDialog() {
      if (this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.WATCHLIST.id) &&
        this.watchlists.length >= this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.WATCHLIST.id)) {
        let newCount = this.watchlists.length
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.WATCHLIST.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY, {itemAmount: ++newCount})
      } else {
        this.$confirm({
          title: 'Neue Watchlist',
          titleWithLexikonLink: false,
          text: 'Wie soll deine Watchlist heißen?',
          textWithLexikonLink: false,
          input: true,
          inputMultiline: false,
          inputLabel: 'Wie soll deine Watchlist heißen?',
          inputPlaceholder: 'Meine Watchlist',
          confirmBtn: 'Speichern'
        }).then((params) => {
          this.createWatchlist(params.inputText)
        })
      }
    },
    createWatchlist(name) {
      finWatchlistAPI.createWatchlist({name: name}).then(
        params => {
          this.watchlists = [params, ...this.watchlists]
          this.$toasted.global.finToast({
            message: 'Deine neue Watchlist %name% wurde erstellt.',
            placeholders: [{name: 'name', content: params.name}],
            type: 'success',
            options: {
              action: {
                text: 'Zur Watchlist',
                push: {name: 'watchlistDetails', params: {id: params.id}}
              }
            }
          })
        }).catch(error => {
        console.error('Failed to create watchlist ' + name, error)
        this.$toasted.global.finToast({
          message: 'Deine Watchlist %watchlistName% konnte nicht erstellt werden.',
          placeholders: [{name: "watchlistName", content: name}],
          type: 'error'
        })
      })
    },
    onScroll() {
      let sroll = window.scrollY
      if (sroll > 120) {
        sroll = 120
      }

      this.illustrationHeight = 90 + 50 - map(sroll, 0, 120, 0, 50)
      this.greetingTopMargin = -55 - 95 + map(sroll, 0, 120, 0, 95)
    },
    resetOnboardingData() {
      this.updateOnboarding('{}').then(data => {
        this.$router.push({name: 'onbgetstarted', params: {continue: 'continue'}})
      }).catch(this.setError)
    },
  },
  async mounted() {
    Analytics.record({name: 'myFinHubVisit'})

    if (this.prevRoute?.includes('/finNews/')) {
      this.$nextTick(() => {
        this.$vuetify.goTo('#fin-news', {duration: 500, easing: 'easeInOutCubic'})
      })
    }
    //console.log("Env: "+process.env.NODE_ENV)
  },
  async beforeMount() {
    if (LexiconAPI.hasContextHelp(this.$route.name)) {
      const contextHelp = await LexiconAPI.loadContextHelp(this.$route.name)
      this.tours = contextHelp.body.filter(entry => entry.type === "tour")
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.fullPath
    })
  },
}
</script>

<style lang="scss" scoped>

.capital-inputfield {
  width: 272px;

  ::v-deep .v-input__slot {
    box-shadow: $fin-color-shadow;
    border: solid 1px #cfd1d3;
    background-color: #ffffff;
  }
}

::v-deep .capital-inputfield input {
  text-align: right !important;
}

.capital-inputfield ::v-deep .v-text-field__suffix {
  padding-left: 0;
  color: black;
}

</style>
